module.exports = __webpack_public_path__ + "img/CrossCorrelation2.165011e1.png";